import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

export function AccountNameFields({
  defaultValues = {},
  disabled = false,
  disabledFields = [],
  autoFocus = false,
}) {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          id="firstName"
          name="firstName"
          label="First Name"
          autoComplete="given-name"
          autoFocus={autoFocus}
          defaultValue={defaultValues.firstName || ""}
          disabled={disabled || disabledFields.includes("firstName")}
          variant="outlined"
          fullWidth
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          id="lastName"
          name="lastName"
          label="Last Name"
          autoComplete="family-name"
          defaultValue={defaultValues.lastName || ""}
          disabled={disabled || disabledFields.includes("lastName")}
          variant="outlined"
          fullWidth
          required
        />
      </Grid>
    </>
  );
}

export function AccountPhoneField({
  defaultValue = "",
  disabled = false,
  required,
}) {
  return (
    <Grid item xs={12}>
      <TextField
        id="phoneNumber"
        name="phoneNumber"
        label="Phone Number"
        type="tel"
        autoComplete="tel"
        defaultValue={defaultValue || ""}
        disabled={disabled}
        variant="outlined"
        fullWidth
        required={required}
      />
    </Grid>
  );
}
